module.exports = __webpack_public_path__ + "static/media/kamera-v.94ead903.mp4";